module.exports = __webpack_public_path__ + "static/4-cc59c97002542bdf6156f83491372b74.jpg";